import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { useNavigate, useParams } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import {
  createPrimary,
  getParents,
  getProject,
  updatePrimary,
} from "../../api/Primary";

const UpdatePrimaryPage = () => {
  const navigate = useNavigate();
  const params = useParams();
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [parentsAndCities, setParentsAndCities] = useState(null);
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState();

  const [images, setImages] = useState([]);
  const [oldImages, setOldImages] = useState([]);

  const [filesChoose, setFilesChoose] = useState({
    logo: null,
    masterPlan: null,
  });

  const [formData, setFormData] = useState(null);

  const masterTypes = [
    {
      id: 1,
      name: "Residential",
    },
    {
      id: 2,
      name: "Commercial",
    },
  ];

  useEffect(() => {
    getProject(params.id).then((result) => {
      console.log(result.data.project);
      setFormData({
        name: result.data.project.name,
        images: result.data.project.images,
        description: result.data.project.description,
        isLaunch: result.data.project.isLaunch,
        areaName: result.data.project.areaName,
        developerName: result.data.project.developerName,
        developerLogoUrl: result.data.project.developerLogoUrl,
        masterPlan: result.data.project.masterPlan,
        developerStartingPrice:
          result.data.project.prices.developerStartingPrice,
        paymentPlans: result.data.project.paymentPlans,
        phases: result.data.project.phases,
        isEnable: result.data.project.isEnable,
        locationMap: result.data.project.locationMap,
        startDeliveryDate: result.data.project.startDeliveryDate || "",
        endDeliveryDate: result.data.project.endDeliveryDate || "",
        DeveloperCommission: result.data.project.DeveloperCommission,
        CommissionBroker: result.data.project.CommissionBroker,
        CommissionBrokerOnSpot: result.data.project.CommissionBrokerOnSpot,
        CommissionFranchise: result.data.project.CommissionFranchise,
        CommissionFranchiseOnSpot:
          result.data.project.CommissionFranchiseOnSpot,
        Taxes: result.data.project.Taxes,
        BrokerBonus: result.data.project.BrokerBonus,
        WhatsApp: result.data.project.WhatsApp,
        Group: result.data.project.Group,
        uploadFrom: result.data.project.uploadFrom,
        DataSectionId: result.data.project.DataSectionId,
      });
      const list = result.data.project.propertyTypes.map((item) => item.name);
      setTypes(list);
    });
    getParents().then((result) => {
      setParentsAndCities(result.data);
    });
  }, []);

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const validTypes = ["image/jpg", "image/png", "image/jpeg"];
    const invalidFiles = files.filter(
      (file) => !validTypes.includes(file.type),
    );

    if (invalidFiles.length > 0) {
      alert("Only JPG, PNG, or JPEG files are allowed");
      return;
    }

    setImages((prevImages) => [...prevImages, ...files]);
  };

  const removeImage = (index) => {
    const imageToRemove = formData.images[index];
    setFormData((prev) => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index),
    }));
    setOldImages((prev) => [...prev, imageToRemove]);
  };

  const removeImageFile = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChooseFiles = (e, name) => {
    e.target.setCustomValidity("");
    setFilesChoose((prev) => ({
      ...prev,
      [name]: e.target.files[0],
    }));
  };

  const formatPrice = (value) => {
    return new Intl.NumberFormat().format(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const formBack = new FormData();
    formBack.append("name", formData.name);
    formBack.append("description", formData.description);
    formBack.append("isLaunch", formData.isLaunch);
    formBack.append("areaName", formData.areaName);
    formBack.append("developerName", formData.developerName);
    formBack.append("developerStartingPrice", formData.developerStartingPrice);
    formBack.append("paymentPlans", JSON.stringify(formData.paymentPlans));
    formBack.append("propertyTypes", JSON.stringify(types));
    formBack.append("isEnable", formData.isEnable);
    formBack.append("DataSectionId", formData.DataSectionId);
    if (formData.startDeliveryDate || formData.startDeliveryDate !== "") {
      formBack.append("startDeliveryDate", formData.startDeliveryDate);
    }
    if (formData.endDeliveryDate || formData.endDeliveryDate !== "") {
      formBack.append("endDeliveryDate", formData.endDeliveryDate);
    }
    formBack.append("locationMap", formData.locationMap);
    formBack.append("oldImages", JSON.stringify(oldImages));
    if (filesChoose.logo !== null) {
      formBack.append("logo", filesChoose.logo);
    }
    if (filesChoose.masterPlan !== null) {
      formBack.append("masterPlan", filesChoose.masterPlan);
    }
    formBack.append(
      "DeveloperCommission",
      formData.DeveloperCommission === "" ? 0 : formData.DeveloperCommission,
    );
    formBack.append(
      "CommissionBroker",
      formData.CommissionBroker === "" ? 0 : formData.CommissionBroker,
    );
    formBack.append(
      "CommissionBrokerOnSpot",
      formData.CommissionBrokerOnSpot === ""
        ? 0
        : formData.CommissionBrokerOnSpot,
    );
    formBack.append(
      "CommissionFranchise",
      formData.CommissionFranchise === "" ? 0 : formData.CommissionFranchise,
    );
    formBack.append(
      "CommissionFranchiseOnSpot",
      formData.CommissionFranchiseOnSpot === ""
        ? 0
        : formData.CommissionFranchiseOnSpot,
    );
    formBack.append("Taxes", formData.Taxes === "" ? 0 : formData.Taxes);
    formBack.append(
      "BrokerBonus",
      formData.BrokerBonus === "" ? 0 : formData.BrokerBonus,
    );
    formBack.append("WhatsApp", formData.WhatsApp);
    formBack.append("Group", formData.Group);
    for (let i = 0; i < images.length; i++) {
      formBack.append("images", images[i]);
    }

    updatePrimary(params.id, formBack).then((result) => {
      if (result.data.message === "Primary is updated") {
        toast.success("Primary is updated", {
          position: "top-right",
        });
        navigate(-1);
      }
      setLoading(false);
    });
  };

  const inputStyle = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: 0,
  };

  const labelStyle = {
    display: "inline-block",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
  };

  const labelDeleteStyle = {
    display: "inline-block",
    padding: "10px",
    backgroundColor: "red",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
    margin: "0px",
  };

  const handleChangePaymentPlan = (index, field, value) => {
    setFormData((prev) => {
      const updatedPlans = [...prev.paymentPlans];
      updatedPlans[index] = {
        ...updatedPlans[index],
        [field]: value,
      };

      return {
        ...prev,
        paymentPlans: updatedPlans,
      };
    });
  };

  const removePaymentPlan = (indexToRemove) => {
    if (formData.paymentPlans.length > 1) {
      setFormData((prev) => ({
        ...prev,
        paymentPlans: prev.paymentPlans.filter(
          (_, index) => index !== indexToRemove,
        ),
      }));
    }
  };

  const addPaymentPlan = () => {
    if (formData.paymentPlans.length < 4) {
      setFormData((prev) => ({
        ...prev,
        paymentPlans: [
          ...prev.paymentPlans,
          {
            installmentPercentage: 1,
            downPaymentPercentage: "",
            years: "",
            isBackLoaded: false,
          },
        ],
      }));
    }
  };

  const toggleTypes = (type) => {
    setTypes((prev) => {
      if (prev.includes(type)) {
        return prev.filter((item) => item !== type);
      } else {
        return [...prev, type];
      }
    });
  };

  return (
    <div className="main-content">
      {parentsAndCities === null || formData === null ? (
        <LoadingPage />
      ) : (
        <div className="add-brokers-guideline">
          <form onSubmit={handleSubmit}>
            <label htmlFor="image">Images</label>
            <div className="image-previews">
              {formData.images.map((image, imageIndex) => (
                <div key={image} className="preview-item">
                  <img src={image} alt={`Preview ${imageIndex}`} />
                  <button onClick={() => removeImage(imageIndex)}>×</button>
                </div>
              ))}
              {images.map((image, imageIndex) => (
                <div key={image} className="preview-item">
                  <img
                    src={URL.createObjectURL(image)}
                    alt={`Preview ${imageIndex}`}
                  />
                  <button onClick={() => removeImageFile(imageIndex)}>×</button>
                </div>
              ))}
            </div>

            <div className="form-group">
              <div style={{ position: "relative", marginTop: "16px" }}>
                <input
                  type="file"
                  id="images"
                  name="images"
                  onChange={handleFileChange}
                  multiple
                  accept="image/jpg, image/png, image/jpeg"
                  style={inputStyle}
                />
                <label htmlFor="images" style={labelStyle}>
                  Choose Images
                </label>
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="logo">Developer Logo</label>
                <div style={{ position: "relative", marginTop: "16px" }}>
                  {filesChoose.logo === null ? (
                    <>
                      {formData.developerLogoUrl !== null &&
                        formData.developerLogoUrl !== "" && (
                          <div className="preview-item">
                            <img src={formData.developerLogoUrl} alt="logo" />
                          </div>
                        )}
                    </>
                  ) : (
                    <div className="preview-item">
                      <img
                        src={URL.createObjectURL(filesChoose.logo)}
                        alt="logo"
                      />
                    </div>
                  )}
                  <input
                    type="file"
                    id="logo"
                    name="logo"
                    onChange={(e) => handleChooseFiles(e, "logo")}
                    accept="image/jpg, image/png, image/jpeg"
                    style={inputStyle}
                    onInvalid={(e) =>
                      e.target.setCustomValidity("Logo english is required")
                    }
                  />
                  <label htmlFor="logo" style={labelStyle}>
                    {filesChoose.logo ? "Change Logo" : "Choose Logo"}
                  </label>
                </div>
              </div>
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="logo">Master plan</label>
                <div style={{ position: "relative", marginTop: "16px" }}>
                  {filesChoose.masterPlan === null ? (
                    <>
                      {formData.masterPlan !== null &&
                        formData.masterPlan !== "" && (
                          <div className="preview-item">
                            <img src={formData.masterPlan} alt="masterPlan" />
                          </div>
                        )}
                    </>
                  ) : (
                    <div className="preview-item">
                      <img
                        src={URL.createObjectURL(filesChoose.masterPlan)}
                        alt="masterPlan"
                      />
                    </div>
                  )}
                  <input
                    type="file"
                    id="masterPlan"
                    name="masterPlan"
                    onChange={(e) => handleChooseFiles(e, "masterPlan")}
                    accept="image/jpg, image/png, image/jpeg"
                    style={inputStyle}
                    onInvalid={(e) =>
                      e.target.setCustomValidity("Master plan is required")
                    }
                  />
                  <label htmlFor="masterPlan" style={labelStyle}>
                    {filesChoose.masterPlan
                      ? "Change Master plan"
                      : "Choose Master plan"}
                  </label>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="Developer name">Developer name</label>
              <input
                type="text"
                id="developerName"
                name="developerName"
                value={formData.developerName}
                onChange={handleChange}
                placeholder="Enter developer name"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Developer name is required")
                }
              />
            </div>

            <div className="form-group">
              <label htmlFor="Title">Title</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Title"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Title is required")
                }
              />
            </div>

            <div className="form-group">
              <label htmlFor="description">Description</label>
              <textarea
                type="text"
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Enter description"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Description is required")
                }
              />
            </div>

            <div className="form-group">
              <label
                htmlFor="areaName"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Location
              </label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select location"
                name="areaName" // Changed from type2 to be more descriptive
                value={formData.areaName}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    areaName: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Location is required")
                }
              >
                <option disabled value="">
                  Select Location
                </option>
                {parentsAndCities.cities?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label htmlFor="developerStartingPrice">Price</label>
              <input
                type="number"
                id="developerStartingPrice"
                name="developerStartingPrice"
                value={formData.developerStartingPrice}
                onChange={handleChange}
                placeholder="Enter price"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Price is required")
                }
              />
            </div>
            <div className="form-group">
              <label htmlFor="locationMap">Location Map</label>
              <input
                type="text"
                id="locationMap"
                name="locationMap"
                value={formData.locationMap}
                onChange={handleChange}
                placeholder="Enter Location Map"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Location Map is required")
                }
              />
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="startDeliveryDate">Start Delivery Date</label>
                <input
                  type="date"
                  id="startDeliveryDate"
                  name="startDeliveryDate"
                  value={formData.startDeliveryDate.split("T")[0]}
                  onChange={handleChange}
                  placeholder="Enter Start  Delivery Date"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity(
                      "Start Delivery Date is required",
                    )
                  }
                />
              </div>
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="endDeliveryDate">End Delivery Date</label>
                <input
                  type="date"
                  id="endDeliveryDate"
                  name="endDeliveryDate"
                  value={formData.endDeliveryDate.split("T")[0]}
                  onChange={handleChange}
                  placeholder="Enter End  Delivery Date"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("End Delivery Date is required")
                  }
                />
              </div>
            </div>

            <div
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "bold",
                color: "#555",
              }}
            >
              <label htmlFor="paymentPlans">Payment Plans</label>
            </div>

            {formData.paymentPlans.map((item, pIndex) => (
              <div
                key={pIndex}
                style={{
                  display: "flex",
                  width: "100%",
                  gap: "15px", // Better than space-between for consistent spacing
                  flexWrap: "wrap",
                  border: "2px solid #3498db",
                  borderRadius: "4px",
                  padding: "10px",
                  marginBottom: "5px",
                }}
              >
                <div className="choices-container">
                  <div
                    className="form-group"
                    style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <input
                        type="number"
                        id="downPaymentPercentage"
                        name="downPaymentPercentage"
                        value={item.downPaymentPercentage}
                        onChange={(e) => {
                          e.target.setCustomValidity("");
                          handleChangePaymentPlan(
                            pIndex,
                            "downPaymentPercentage",
                            e.target.value,
                          );
                        }}
                        placeholder={`Enter down payment percentage (${pIndex + 1})      %`}
                        required={true}
                        onInvalid={(e) => {
                          e.target.setCustomValidity(
                            `Down payment percentage percentage ${pIndex + 1} is required`,
                          );
                        }}
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#000",
                        }}
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div
                    className="form-group"
                    style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                  >
                    <input
                      type="number"
                      id="years"
                      name="years"
                      value={item.years}
                      onChange={(e) => {
                        e.target.setCustomValidity("");
                        handleChangePaymentPlan(
                          pIndex,
                          "years",
                          e.target.value,
                        );
                      }}
                      placeholder={`Enter years (${pIndex + 1})`}
                      required={true}
                      onInvalid={(e) => {
                        e.target.setCustomValidity(
                          `Years ${pIndex + 1} is required`,
                        );
                      }}
                    />
                  </div>
                </div>
                {formData.paymentPlans.length > 1 && (
                  <div
                    className="form-group"
                    style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                  >
                    <label
                      htmlFor="addPaymentPlan"
                      style={labelDeleteStyle}
                      onClick={() => removePaymentPlan(pIndex)}
                    >
                      Remove this payment plan
                    </label>
                  </div>
                )}
              </div>
            ))}

            {formData.paymentPlans.length < 4 && (
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label
                  htmlFor="addPaymentPlan"
                  style={labelStyle}
                  onClick={() => addPaymentPlan()}
                >
                  Add more payment plan
                </label>
              </div>
            )}

            {formData.uploadFrom === "Master V" ? (
              <div className="form-group">
                <label
                  htmlFor="Type"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  Type
                </label>
                <select
                  className="form-select form-control form-select-lg border border-dark"
                  aria-label="Select Type"
                  name="areaName" // Changed from type2 to be more descriptive
                  value={formData.DataSectionId}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setFormData({
                      ...formData,
                      DataSectionId: e.target.value,
                    });
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "16px",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                  }}
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Location is required")
                  }
                >
                  <option disabled value="">
                    Select Type
                  </option>
                  {masterTypes?.map((item) => (
                    <option key={item.id} value={item.it}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              <div style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}>
                <div
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    color: "#555",
                  }}
                >
                  <label htmlFor="Types">Types</label>
                </div>

                <div style={{ paddingBottom: "10px" }}>
                  {parentsAndCities.types.map((type) => (
                    <div key={type} onClick={() => toggleTypes(type)}>
                      <input
                        type="checkbox"
                        checked={types.includes(type)}
                        onChange={() => { }}
                        className="client-checkbox"
                      />
                      <label
                        htmlFor="Down payment"
                        style={{ paddingLeft: "10px" }}
                      >
                        {type}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="WhatsApp">WhatsApp number</label>
                <input
                  type="text"
                  id="WhatsApp"
                  name="WhatsApp"
                  value={formData.WhatsApp}
                  onChange={handleChange}
                  placeholder="Enter WhatsApp number"
                  maxLength="11"
                  pattern="^01[0-2,5]\d{1,8}$"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("WhatsApp is required")
                  }
                />
              </div>
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="Group">WhatsApp group link</label>
                <input
                  type="text"
                  id="Group"
                  name="Group"
                  value={formData.Group}
                  onChange={handleChange}
                  placeholder="Enter whatsApp group link"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity(
                      "WhatsApp group link is required",
                    )
                  }
                />
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="DeveloperCommission">
                  Developer commission %
                </label>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    id="DeveloperCommission"
                    name="DeveloperCommission"
                    value={formData.DeveloperCommission}
                    onChange={handleChange}
                    placeholder="Enter DeveloperCommission %"
                    pattern="^\d+(\.\d{1,10})?$"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity(
                        "Developer commission is required",
                      )
                    }
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#000",
                    }}
                  >
                    %
                  </span>
                </div>
              </div>

              {isSuper && (
                <div
                  className="form-group"
                  style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                >
                  <label htmlFor="Taxes">Taxes %</label>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <input
                      type="text"
                      id="Taxes"
                      name="Taxes"
                      value={formData.Taxes}
                      onChange={handleChange}
                      placeholder="Enter taxes %"
                      pattern="^\d+(\.\d{1,10})?$"
                      required
                      onInvalid={(e) =>
                        e.target.setCustomValidity("Taxes is required")
                      }
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "#000",
                      }}
                    >
                      %
                    </span>
                  </div>
                </div>
              )}
            </div>

            {isSuper && (
              <>
                <div
                  className="choices-container"
                  style={{
                    display: "flex",
                    width: "100%",
                    gap: "15px", // Better than space-between for consistent spacing
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    className="form-group"
                    style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                  >
                    <label htmlFor="CommissionBroker">
                      Commission broker %
                    </label>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <input
                        type="text"
                        id="CommissionBroker"
                        name="CommissionBroker"
                        value={formData.CommissionBroker}
                        onChange={handleChange}
                        placeholder="Enter CommissionBroker %"
                        pattern="^\d+(\.\d{1,10})?$"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity(
                            "Commission broker is required",
                          )
                        }
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#000",
                        }}
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div
                    className="form-group"
                    style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                  >
                    <label htmlFor="CommissionBrokerOnSpot">
                      Commission broker onSpot %
                    </label>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <input
                        type="text"
                        id="CommissionBrokerOnSpot"
                        name="CommissionBrokerOnSpot"
                        value={formData.CommissionBrokerOnSpot}
                        onChange={handleChange}
                        placeholder="Enter CommissionBrokerOnSpot %"
                        pattern="^\d+(\.\d{1,10})?$"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity(
                            "Commission broker onSpot is required",
                          )
                        }
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#000",
                        }}
                      >
                        %
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  className="choices-container"
                  style={{
                    display: "flex",
                    width: "100%",
                    gap: "15px", // Better than space-between for consistent spacing
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    className="form-group"
                    style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                  >
                    <label htmlFor="CommissionFranchise">
                      Commission franchise %
                    </label>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <input
                        type="text"
                        id="CommissionFranchise"
                        name="CommissionFranchise"
                        value={formData.CommissionFranchise}
                        onChange={handleChange}
                        placeholder="Enter CommissionFranchise %"
                        pattern="^\d+(\.\d{1,10})?$"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity(
                            "Commission franchise is required",
                          )
                        }
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#000",
                        }}
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div
                    className="form-group"
                    style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                  >
                    <label htmlFor="CommissionFranchiseOnSpot">
                      Commission franchise onSpot %
                    </label>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <input
                        type="text"
                        id="CommissionFranchiseOnSpot"
                        name="CommissionFranchiseOnSpot"
                        value={formData.CommissionFranchiseOnSpot}
                        onChange={handleChange}
                        placeholder="Enter CommissionFranchiseOnSpot %"
                        pattern="^\d+(\.\d{1,10})?$"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity(
                            "Commission franchise onSpot is required",
                          )
                        }
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#000",
                        }}
                      >
                        %
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  className="form-group"
                  style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                >
                  <label htmlFor="BrokerBonus">Broker Bonus %</label>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <input
                      type="text"
                      id="BrokerBonus"
                      name="BrokerBonus"
                      value={formData.BrokerBonus}
                      onChange={handleChange}
                      placeholder="Enter Broker Bonus %"
                      pattern="^\d+(\.\d{1,10})?$"
                      required
                      onInvalid={(e) =>
                        e.target.setCustomValidity("Broker bonus is required")
                      }
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "#000",
                      }}
                    >
                      %
                    </span>
                  </div>
                </div>
              </>
            )}

            <div
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  isEnable: !prev.isEnable,
                }))
              }
            >
              <input
                type="checkbox"
                checked={formData.isEnable}
                onChange={() => { }}
                className="client-checkbox"
              />
              <label htmlFor="isEnable" style={{ paddingLeft: "10px" }}>
                Available
              </label>
            </div>

            <div
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  isLaunch: !prev.isLaunch,
                }))
              }
            >
              <input
                type="checkbox"
                checked={formData.isLaunch}
                onChange={() => { }}
                className="client-checkbox"
              />
              <label htmlFor="isLaunch" style={{ paddingLeft: "10px" }}>
                New Launch
              </label>
            </div>

            {loading ? (
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div className="spinner"></div>
              </div>
            ) : (
              <button type="submit" className="submit-button">
                Update Project
              </button>
            )}
          </form>
          <ToastContainer />
        </div>
      )}
    </div>
  );
};

export default UpdatePrimaryPage;
